export default __webpack_public_path__ + "static/media/Helvetica Neue LT 45 Light.9eafded6.ttf";